import React from "react";
import PageLayout from "../../shared/PageLayout";
import NewCaseLayout from "./NewCaseLayout";

const NewCase: React.FC = () => {
    return (
        <PageLayout>
            <NewCaseLayout />
        </PageLayout>
    );
};

export default NewCase;
